import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { V2BottomSheetRef } from '../../../v2-components/helpers/v2-bottom-sheet-ref';

@Component({
  selector: 'verify-bill-selection',
  template: `
    <v2-column id="top-column">
      <v2-row alignItems="center">
        <v2-icon
          id="error-icon"
          icon="error-warning"
          color="alert-orange">
        </v2-icon>
        <v2-body-header-0-text color="black">
          Payment Session Expired
        </v2-body-header-0-text>
      </v2-row>
      <v2-body-large-text id="description-text" color="black">
        Please verify your bill selection and try again.
      </v2-body-large-text>
    </v2-column>
    <v2-button color="primary" [outline]="true" (click)="onDismiss()">BACK</v2-button>
  `,
  styles: [
    `
      #top-column {
        padding: 30px 16px 28px;
      }
      #error-icon {
        font-size: 24px;
        margin-right: 10px;
      }
      #description-text {
        margin-top: 12px;
      }
      v2-button {
        margin: 0 8px 8px 8px;
      }
    `
  ]
})
export class VerifyBillSelectionSheet {
  constructor(
    public bottomSheetRef: V2BottomSheetRef,
    public navController: NavController
  ) {}

  onDismiss() {
    this.bottomSheetRef.close();
    this.navController.pop();
  }
}
